// extracted by mini-css-extract-plugin
module.exports = {"investGrowWithdrawContainer":"_3IXMx","tabPanel":"_1Ni2V","tabPanel--image":"_3lp7S","tabPanel--learnMoreLink":"L9f91","tabPanel--contentContainer":"rySRP"};